import React from 'react';

const styles = {
  noData: {
    textAlign: 'center',
    fontSize: 20,
    margin: 100
  }
}

const NoSchedule = () => (
  <div style={styles.noData}> No Schedule Available.</div>
);

export default NoSchedule;


// WEBPACK FOOTER //
// ./src/screens/schedules/slots/no-schedule.js